import {faMinus,faPlus,faSignInAlt,faUserShield,  faChevronDown} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from 'react-router-dom';
import { cargarCategorias, obtenerProductos ,getPrecioProducto,obtenerTotalProductos,obtenerProductosRecomendados} from './servicios/supabase-funciones';
import { scrollearSeccion } from './scrollear_seccion';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faCartShopping, faUser, faSearch, faHome, faBook, faTags, faInfoCircle, faBars, faWineBottle, faBeer, faWineGlass, faWineGlassAlt, faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useRef } from 'react';
import logo from './logogrande.png';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { supabase } from './servicios/supabaseClient';
import './App.css';
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function Home() {
  // Estructura de grupos y categorías

// Modificar la función cambiarImagenCatalogo para usar productosFiltradosCompletos





  const gruposCategorias = [
    {
      id: 1,
      nombre: 'Vinos',
      icono: faWineBottle,
      categorias: ['Tinto', 'Blanco', 'Rosado']
    },
    {
      id: 2,
      nombre: 'Espumantes',
      icono: faWineGlassAlt,
      categorias: ['Espumante', 'Sidra']
    },
    {
      id: 3,
      nombre: 'Cervezas',
      icono: faBeer,
      categorias: ['Con alcohol', 'Sin alcohol']
    },
    {
      id: 4,
      nombre: 'Destilados',
      icono: faWineGlass,
      categorias: ['Destilados']
    },
    {
      id: 5,
      nombre: 'Otros',
      icono: faShoppingBasket,
      categorias: ['Yerba', 'Aceite']
    }
  ];
// Estados adicionales para el menú móvil
const [grupoAbiertoMobile, setGrupoAbiertoMobile] = useState(null);

// Función para manejar clic en grupo en móvil
const handleGrupoMobileClick = (grupo) => {
  if (grupoAbiertoMobile?.id === grupo.id) {
    setGrupoAbiertoMobile(null);
  } else {
    setGrupoAbiertoMobile(grupo);
  }
};

// También modificar handleSubcategoriaMobileClick
const handleSubcategoriaMobileClick = (grupo, subcategoria) => {
  // Verificar si la subcategoría tiene productos
  const tieneProductos = todosLosProductos.some(p => p.categoria === subcategoria);
  
  if (!tieneProductos && subcategoria !== 'Todas') {
    alert(`La categoría "${subcategoria}" no tiene productos disponibles en este momento.`);
    
    // Opcional: volver a "Todas"
    // setGrupoActivo(grupo);
    // setSubcategoriaActiva('Todas');
    // setCategoriaActiva('Todas');
    
    return;
  }
  
  setGrupoActivo(grupo);
  setSubcategoriaActiva(subcategoria);
  setCategoriaActiva(subcategoria);
  setPaginaActual(1);
  setGrupoAbiertoMobile(null);
  toggleMenu();
  
  setTimeout(() => {
    scrollearSeccion("catalogo_seccion");
  }, 100);
};
  // Estado para el grupo activo
  const [grupoActivo, setGrupoActivo] = useState(null);
  const [subcategoriaActiva, setSubcategoriaActiva] = useState('Todas');

  // Estado para el ordenamiento
  const [orden, setOrden] = useState('orden');
    // Estados MODIFICADOS para la carga de TODOS los productos
  const [todosLosProductos, setTodosLosProductos] = useState([]); // NUEVO: Todos los productos
  const [productosFiltradosCompletos, setProductosFiltradosCompletos] = useState([]); // NUEVO: Productos filtrados y ordenados
  const [cargandoCompleto, setCargandoCompleto] = useState(false); // NUEVO
  // Estados para la carga paginada
  const [productos, setProductos] = useState([]);
  const [totalProductos, setTotalProductos] = useState(0);
  const [cargando, setCargando] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [productosPorPagina] = useState(6);
  const [productosPaginaActual, setProductosPaginaActual] = useState([]); // NUEVO: Productos de la página actual

  // Estados para productos recomendados (carga separada)
  const [productosRecomendados, setProductosRecomendados] = useState([]);
  const [indiceCarruselRecomendados, setIndiceCarruselRecomendados] = useState(0);
  
  // Estados para precios
  const [preciosProductos, setPreciosProductos] = useState({});
  const [preciosRecomendados, setPreciosRecomendados] = useState({});
  
  const [imagenesPrecargadas, setImagenesPrecargadas] = useState(false);
  const [carrito, setCarrito] = useState(() => {
    const carritoGuardado = localStorage.getItem("carrito");
    return carritoGuardado ? JSON.parse(carritoGuardado) : [];
  });

  // Estado para controlar las categorías
  const [categoriasAbierto, setCategoriasAbierto] = useState(false);
  
  // Estados separados para imágenes
  const [indicesImagenesRecomendados, setIndicesImagenesRecomendados] = useState({});
  const [indicesImagenesCatalogo, setIndicesImagenesCatalogo] = useState({});
  const [transicionImagenRecomendados, setTransicionImagenRecomendados] = useState({});
  const [transicionImagenCatalogo, setTransicionImagenCatalogo] = useState({});

  const [tachado, setTachado] = useState([false, false]);
  const [fotos, setFotos] = useState([null, null]);
  const [vistasPrevias, setVistasPrevias] = useState([null, null]);
  const [editandoId, setEditandoId] = useState(null);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [logueado, setLogueado] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [resultados, setResultados] = useState([]);
  const [categoriaActiva, setCategoriaActiva] = useState("Todas");
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [controlEdad, setcontrolEdad] = useState(true);
  const [showSearchMobile, setShowSearchMobile] = useState(false);
  
  const searchRef = useRef(null);
  const navigate = useNavigate();
// Función para limpiar filtros (MEJORADA)

 const handleGrupoClick = (grupo) => {
  setGrupoActivo(grupo);
  setSubcategoriaActiva('Todas');
  setCategoriaActiva('Todas');
  // NO hacemos setPaginaActual(1) ni scroll aquí
  // Solo establecemos el grupo activo
};
// Función para aplicar filtro del grupo (NUEVA)
const aplicarFiltroGrupo = () => {
  if (!grupoActivo) return;
  
  // Si no hay subcategoría activa, mostramos todas las categorías del grupo
  if (subcategoriaActiva === 'Todas') {
    setCategoriaActiva('Todas'); // Esto mostrará todas las categorías del grupo
    setPaginaActual(1);
    
    setTimeout(() => {
      scrollearSeccion("catalogo_seccion");
    }, 100);
  }
};
  // Modificar la función handleSubcategoriaClick para manejar casos sin productos
const handleSubcategoriaClick = (subcategoria) => {
  // Verificar si la subcategoría tiene productos
  const tieneProductos = todosLosProductos.some(p => p.categoria === subcategoria);
  
  if (!tieneProductos && subcategoria !== 'Todas') {
    // Mostrar alerta o mensaje informativo
    alert(`La categoría "${subcategoria}" no tiene productos disponibles en este momento.`);
    
    // Opcional: puedes mantener la selección o volver a "Todas"
    // Opción 1: Mantener selección pero mostrar mensaje
    setSubcategoriaActiva(subcategoria);
    setCategoriaActiva(subcategoria);
    
    // Opción 2: Volver a "Todas" automáticamente
    // setSubcategoriaActiva('Todas');
    // setCategoriaActiva('Todas');
    
    return;
  }
  
  setSubcategoriaActiva(subcategoria);
  setCategoriaActiva(subcategoria);
  
  setTimeout(() => {
    scrollearSeccion("catalogo_seccion");
  }, 100);
};



// Primero, vamos a crear una función para verificar si una categoría tiene productos
const categoriaTieneProductos = (categoria) => {
  if (categoria === "Todas") return true;
  
  return todosLosProductos.some(p => p.categoria === categoria);
};

// También podemos verificar si un grupo tiene productos
const grupoTieneProductos = (grupo) => {
  if (!grupo) return false;
  
  // Verificar si al menos una categoría del grupo tiene productos
  return grupo.categorias.some(categoria => 
    todosLosProductos.some(p => p.categoria === categoria)
  );
};




  
 // Función para limpiar filtros (MEJORADA)
  const limpiarFiltros = () => {
    setGrupoActivo(null);
    setSubcategoriaActiva('Todas');
    setCategoriaActiva('Todas');
    // El paginado se manejará automáticamente en el efecto
    
    setTimeout(() => {
      scrollearSeccion("catalogo_seccion");
    }, 100);
  };
  // Función para precargar imágenes (optimizada para paginación)
  
  // Modificar la función precargarImagenesPaginadas
  const precargarImagenesPaginadas = (productosActuales) => {
    const imagenesAPrecargar = [];
    
    productosActuales.forEach(producto => {
      if (producto.imagen_url) imagenesAPrecargar.push(producto.imagen_url);
      if (producto.image_url_2) imagenesAPrecargar.push(producto.image_url_2);
    });

    let cargadas = 0;
    const totalImagenes = imagenesAPrecargar.length;

    if (totalImagenes === 0) {
      setImagenesPrecargadas(true);
      return;
    }

    imagenesAPrecargar.forEach(src => {
      const img = new Image();
      img.onload = () => {
        cargadas++;
        if (cargadas === totalImagenes) {
          setImagenesPrecargadas(true);
        }
      };
      img.onerror = () => {
        cargadas++;
        if (cargadas === totalImagenes) {
          setImagenesPrecargadas(true);
        }
      };
      img.src = src;
    });

    setTimeout(() => {
      setImagenesPrecargadas(true);
    }, 3000);
  };

  // NUEVA FUNCIÓN: Cargar TODOS los productos una sola vez
  useEffect(() => {
    const cargarTodosLosProductos = async () => {
      setCargandoCompleto(true);
      try {
        // Cargar todos los productos sin paginación
        let todosProductos = [];
        let pagina = 1;
        let hayMasProductos = true;
        const limitePorPagina = 100; // Supabase tiene un límite por página
        
        while (hayMasProductos) {
          const data = await obtenerProductos(pagina, limitePorPagina, null); // Sin filtro de categoría
          if (data.length === 0) {
            hayMasProductos = false;
          } else {
            todosProductos = [...todosProductos, ...data];
            pagina++;
          }
        }
        
        setTodosLosProductos(todosProductos);
        
        // Cargar precios de todos los productos
        await cargarPreciosTodosProductos(todosProductos);
        
      } catch (error) {
        console.error("❌ Error al cargar todos los productos:", error);
      } finally {
        setCargandoCompleto(false);
      }
    };
    
    cargarTodosLosProductos();
  }, []); // Solo se ejecuta una vez al montar el componente

// NUEVA FUNCIÓN: Cargar precios de TODOS los productos
  const cargarPreciosTodosProductos = async (productos) => {
    try {
      const preciosMap = {};
      
      for (const producto of productos) {
        try {
          const precioData = await getPrecioProducto(producto.id);
          preciosMap[producto.id] = precioData;
        } catch (error) {
          preciosMap[producto.id] = {
            precioNormal: producto.precio,
            precioOferta: null,
            enOferta: false
          };
        }
      }
      
      setPreciosProductos(preciosMap);
    } catch (error) {
      console.error('Error cargando precios de todos los productos:', error);
    }
  };

  // NUEVA FUNCIÓN: Filtrar productos según categorías/grupos
  const filtrarProductosCompletos = () => {
    let productosFiltrados = [...todosLosProductos];
    
    // Aplicar filtros de grupo/subcategoría
    if (grupoActivo && subcategoriaActiva !== 'Todas') {
      productosFiltrados = productosFiltrados.filter(p => 
        grupoActivo.categorias.includes(p.categoria) && p.categoria === subcategoriaActiva
      );
    } else if (grupoActivo && subcategoriaActiva === 'Todas') {
      productosFiltrados = productosFiltrados.filter(p => 
        grupoActivo.categorias.includes(p.categoria)
      );
    } else if (categoriaActiva !== "Todas") {
      productosFiltrados = productosFiltrados.filter(p => p.categoria === categoriaActiva);
    }
    
    return productosFiltrados;
  };

  // NUEVA FUNCIÓN: Ordenar productos (aplica a TODOS los productos filtrados)
  const ordenarProductos = (productosParaOrdenar, ordenSeleccionado) => {
    return [...productosParaOrdenar].sort((a, b) => {
      if (ordenSeleccionado === 'precio_asc') {
        return a.precio - b.precio;
      } else if (ordenSeleccionado === 'precio_desc') {
        return b.precio - a.precio;
      } else if (ordenSeleccionado === 'nombre_asc') {
        return a.nombre.localeCompare(b.nombre);
      } else if (ordenSeleccionado === 'nombre_desc') {
        return b.nombre.localeCompare(a.nombre);
      } else if (ordenSeleccionado === 'orden') {
        const ordenA = a.orden !== undefined && a.orden !== null ? parseInt(a.orden) : 9999;
        const ordenB = b.orden !== undefined && b.orden !== null ? parseInt(b.orden) : 9999;
        return ordenA - ordenB;
      }
      return 0;
    });
  };
  // Función para precargar imágenes de productos recomendados
  const precargarImagenesRecomendados = (productosRecomendados) => {
    const imagenesAPrecargar = [];
    
    productosRecomendados.forEach(producto => {
      if (producto.imagen_url) imagenesAPrecargar.push(producto.imagen_url);
      if (producto.image_url_2) imagenesAPrecargar.push(producto.image_url_2);
    });

    let cargadas = 0;
    const totalImagenes = imagenesAPrecargar.length;

    if (totalImagenes === 0) return;

    imagenesAPrecargar.forEach(src => {
      const img = new Image();
      img.onload = () => {
        cargadas++;
      };
      img.onerror = () => {
        cargadas++;
      };
      img.src = src;
    });
  };

  // Función para cargar precios de productos recomendados
  const cargarPreciosRecomendados = async (productosRecomendados) => {
    try {
      const preciosMap = {};
      
      for (const producto of productosRecomendados) {
        try {
          const precioData = await getPrecioProducto(producto.id);
          preciosMap[producto.id] = precioData;
        } catch (error) {
          console.error(`Error cargando precio para producto recomendado ${producto.id}:`, error);
          preciosMap[producto.id] = {
            precioNormal: producto.precio,
            precioOferta: null,
            enOferta: false
          };
        }
      }
      
      setPreciosRecomendados(preciosMap);
    } catch (error) {
      console.error('Error cargando precios de productos recomendados:', error);
    }
  };

  // Efecto para cargar productos recomendados
  useEffect(() => {
    const cargarProductosRecomendados = async () => {
      try {
        const data = await obtenerProductosRecomendados();
        setProductosRecomendados(data);
        
        // Precargar imágenes de productos recomendados
        precargarImagenesRecomendados(data);
        
        // Cargar precios de productos recomendados
        await cargarPreciosRecomendados(data);
      } catch (error) {
        console.error("❌ Error al cargar productos recomendados:", error);
      }
    };

    cargarProductosRecomendados();
  }, []);

  // Efecto para el carrito
  useEffect(() => {
    localStorage.setItem("carrito", JSON.stringify(carrito));
  }, [carrito]);

  // Funciones para navegar el carrusel
  const siguienteRecomendado = () => {
    if (productosRecomendados.length === 0) return;
    
    setIndiceCarruselRecomendados(prev => 
      prev === Math.ceil(productosRecomendados.length / 4) - 1 ? 0 : prev + 1
    );
    
    setTimeout(() => {
      scrollearSeccion("recomendados");
    }, 50);
  };
  
  const irAPagina = (index) => {
    if (productosRecomendados.length === 0) return;
    
    setIndiceCarruselRecomendados(index);
    
    setTimeout(() => {
      scrollearSeccion("recomendados");
    }, 50);
  };

  const anteriorRecomendado = () => {
    if (productosRecomendados.length === 0) return;
    
    setIndiceCarruselRecomendados(prev => 
      prev === 0 ? Math.ceil(productosRecomendados.length / 4) - 1 : prev - 1
    );
  };

  // Calcular qué productos mostrar según el índice del carrusel
  const productosVisibles = productosRecomendados.length > 0 
    ? productosRecomendados.slice(
        indiceCarruselRecomendados * 4,
        (indiceCarruselRecomendados * 4) + 4
      )
    : [];

  // Funciones para cambiar imágenes
  const cambiarImagenRecomendados = (productoId, direccion) => {
    setTransicionImagenRecomendados(prev => ({
      ...prev,
      [productoId]: `saliente ${direccion}`
    }));

    setTimeout(() => {
      setIndicesImagenesRecomendados(prev => {
        const currentIndex = prev[productoId] || 0;
        const producto = productosRecomendados.find(p => p.id === productoId);
        
        if (!producto) return prev;
        
        const imagen1 = producto.imagen_url;
        const imagen2 = producto.image_url_2;
        const imagenesValidas = [imagen1, imagen2].filter(img => 
          img && typeof img === 'string' && img.trim() !== ''
        );
        
        const totalImagenes = imagenesValidas.length;
        
        if (totalImagenes <= 1) return prev;
        
        let nuevoIndex;
        if (direccion === 'next') {
          nuevoIndex = (currentIndex + 1) % totalImagenes;
        } else {
          nuevoIndex = (currentIndex - 1 + totalImagenes) % totalImagenes;
        }
        
        return {
          ...prev,
          [productoId]: nuevoIndex
        };
      });

      setTimeout(() => {
        setTransicionImagenRecomendados(prev => ({
          ...prev,
          [productoId]: `entrante ${direccion}`
        }));

        setTimeout(() => {
          setTransicionImagenRecomendados(prev => {
            const newState = { ...prev };
            delete newState[productoId];
            return newState;
          });
        }, 400);
      }, 50);
    }, 300);
  };



  // Función para obtener texto descriptivo del orden
const getOrdenText = (orden) => {
  switch(orden) {
    case 'orden': return 'orden personalizado';
    case 'precio_asc': return 'precio (menor a mayor)';
    case 'precio_desc': return 'precio (mayor a menor)';
    case 'nombre_asc': return 'nombre (A-Z)';
    case 'nombre_desc': return 'nombre (Z-A)';
    default: return 'orden predeterminado';
  }
};

  const obtenerImagenActualRecomendados = (producto) => {
    if (!producto || typeof producto !== 'object') {
      return '/placeholder-image.jpg';
    }
    
    const index = indicesImagenesRecomendados[producto.id] || 0;
    const imagen1 = producto.imagen_url;
    const imagen2 = producto.image_url_2;
    
    const imagenes = [imagen1, imagen2].filter(img => 
      img && typeof img === 'string' && img.trim() !== ''
    );
    
    if (imagenes.length === 0) {
      return '/placeholder-image.jpg';
    }
    
    return imagenes[index] || imagenes[0];
  };

  const cambiarImagenCatalogo = (productoId, direccion) => {
    setTransicionImagenCatalogo(prev => ({
      ...prev,
      [productoId]: `saliente ${direccion}`
    }));

    setTimeout(() => {
      setIndicesImagenesCatalogo(prev => {
        const currentIndex = prev[productoId] || 0;
        const producto = productosFiltradosCompletos.find(p => p.id === productoId);
        
        if (!producto) return prev;
        
        const imagen1 = producto.imagen_url;
        const imagen2 = producto.image_url_2;
        const imagenesValidas = [imagen1, imagen2].filter(img => 
          img && typeof img === 'string' && img.trim() !== ''
        );
        
        const totalImagenes = imagenesValidas.length;
        
        if (totalImagenes <= 1) return prev;
        
        let nuevoIndex;
        if (direccion === 'next') {
          nuevoIndex = (currentIndex + 1) % totalImagenes;
        } else {
          nuevoIndex = (currentIndex - 1 + totalImagenes) % totalImagenes;
        }
        
        return {
          ...prev,
          [productoId]: nuevoIndex
        };
      });

      setTimeout(() => {
        setTransicionImagenCatalogo(prev => ({
          ...prev,
          [productoId]: `entrante ${direccion}`
        }));

        setTimeout(() => {
          setTransicionImagenCatalogo(prev => {
            const newState = { ...prev };
            delete newState[productoId];
            return newState;
          });
        }, 400);
      }, 50);
    }, 300);
  };
  const obtenerImagenActualCatalogo = (producto) => {
    if (!producto || typeof producto !== 'object') {
      return '/placeholder-image.jpg';
    }
    
    const index = indicesImagenesCatalogo[producto.id] || 0;
    const imagen1 = producto.imagen_url;
    const imagen2 = producto.image_url_2;
    
    const imagenes = [imagen1, imagen2].filter(img => 
      img && typeof img === 'string' && img.trim() !== ''
    );
    
    if (imagenes.length === 0) {
      return '/placeholder-image.jpg';
    }
    
    return imagenes[index] || imagenes[0];
  };

  // Función genérica para múltiples imágenes
  const tieneMultiplesImagenes = (producto) => {
    if (!producto || typeof producto !== 'object') {
      return false;
    }
    
    const imagen1 = producto.imagen_url;
    const imagen2 = producto.image_url_2;
    
    const imagenesValidas = [imagen1, imagen2].filter(img => 
      img && typeof img === 'string' && img.trim() !== ''
    );
    
    return imagenesValidas.length > 1;
  };

  // Verificar sesión
  useEffect(() => {
    const verificarSesion = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setLogueado(!!session);
    };

    verificarSesion();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setLogueado(!!session);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Barra de busqueda
 const handleSearch = () => {
    if (query.trim() === '') {
      setResultados([]);
      setShowDropdown(false);
      return;
    }

    const res = todosLosProductos
      .filter(p => p.nombre.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 4);

    setResultados(res);
    setShowDropdown(true);
  };
  const handleInputChange = (e) => {
    setQuery(e.target.value);
    if (e.target.value.trim() === '') {
      setShowDropdown(false);
      setResultados([]);
    } else {
      handleSearch();
    }
  };

 // Modificar handleCategoriaClick también
const handleCategoriaClick = (cat) => {
  // Verificar si la categoría tiene productos
  const tieneProductos = todosLosProductos.some(p => p.categoria === cat);
  
  if (!tieneProductos && cat !== "Todas") {
    alert(`La categoría "${cat}" no tiene productos disponibles en este momento.`);
    
    // Opcional: seleccionar "Todas" automáticamente
    // setCategoriaActiva("Todas");
    // setGrupoActivo(null);
    // setSubcategoriaActiva('Todas');
    
    return;
  }
  
  setCategoriaActiva(cat);
  setGrupoActivo(null);
  setSubcategoriaActiva('Todas');
  
  setTimeout(() => {
    scrollearSeccion("catalogo_seccion");
  }, 100);
};

  const añadirAlCarrito = (producto) => {
    const precioData = preciosProductos[producto.id] || preciosRecomendados[producto.id];
    const precioFinal = precioData?.enOferta ? precioData.precioOferta : producto.precio;

    setCarrito(prevCarrito => {
      const productoExistente = prevCarrito.find(p => p.id === producto.id);
      if (productoExistente) {
        return prevCarrito.map(p =>
          p.id === producto.id
            ? { 
                ...p, 
                cantidad: (p.cantidad || 1) + 1,
                precioVenta: precioFinal
              }
            : p
        );
      } else {
        return [...prevCarrito, { 
          ...producto, 
          cantidad: 1,
          precioVenta: precioFinal
        }];
      }
    });
  };

  const eliminarProducto = (id) => {
    setCarrito(prevCarrito => prevCarrito.filter(p => p.id !== id));
  };

  const aumentarCantidad = (id) => {
    setCarrito(prevCarrito =>
      prevCarrito.map(p =>
        p.id === id ? { 
          ...p, 
          cantidad: (p.cantidad || 1) + 1 
        } : p
      )
    );
  };

  const disminuirCantidad = (id) => {
    setCarrito(prevCarrito =>
      prevCarrito
        .map(p =>
          p.id === id ? { 
            ...p, 
            cantidad: (p.cantidad || 1) - 1 
          } : p
        )
        .filter(p => p.cantidad > 0)
    );
  };
  const handleResultadoClick = (producto) => {
    setQuery(producto.nombre);
    setShowDropdown(false);
    setShowSearchMobile(false);
    setCategoriaActiva("Todas");
    setGrupoActivo(null);
    setSubcategoriaActiva('Todas');
    
    scrollearSeccion("catalogo_seccion");
    
    setTimeout(() => {
      const elementoProducto = document.getElementById(`producto-${producto.id}`);
      if (elementoProducto) {
        elementoProducto.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
        
        elementoProducto.style.transition = 'all 0.3s ease';
        elementoProducto.style.boxShadow = '0 0 0 3px #A0522D';
        
        setTimeout(() => {
          elementoProducto.style.boxShadow = '';
        }, 2000);
      }
    }, 500);
  };

  useEffect(() => {
    const edadConfirmada = localStorage.getItem("edadConfirmada");
    if (edadConfirmada === "true") {
      setcontrolEdad(false);
    }
  }, []);

  const confirmarEdad = () => {
    localStorage.setItem("edadConfirmada", "true");
    setcontrolEdad(false);
  };

  // ======== NUEVO SISTEMA - CARGAR TODOS LOS PRODUCTOS ========

  // Cargar TODOS los productos una sola vez
  useEffect(() => {
    const cargarTodosLosProductos = async () => {
      setCargandoCompleto(true);
      try {
        // Cargar todos los productos sin paginación
        let todosProductos = [];
        let pagina = 1;
        let hayMasProductos = true;
        const limitePorPagina = 100;
        
        while (hayMasProductos) {
          const data = await obtenerProductos(pagina, limitePorPagina, null);
          if (data.length === 0) {
            hayMasProductos = false;
          } else {
            todosProductos = [...todosProductos, ...data];
            pagina++;
          }
        }
        
        setTodosLosProductos(todosProductos);
        
        // Cargar precios de todos los productos
        await cargarPreciosTodosProductos(todosProductos);
        
      } catch (error) {
        console.error("❌ Error al cargar todos los productos:", error);
      } finally {
        setCargandoCompleto(false);
      }
    };
    
    cargarTodosLosProductos();
  }, []);

  

  

  
// Aplicar filtros y ordenamiento (modificado)
useEffect(() => {
  if (todosLosProductos.length === 0) return;
  
  // 1. Filtrar productos
  let productosFiltrados = [...todosLosProductos];
  
  // Aplicar filtros de categoría
  if (grupoActivo && subcategoriaActiva !== 'Todas') {
    productosFiltrados = productosFiltrados.filter(p => 
      grupoActivo.categorias.includes(p.categoria) && p.categoria === subcategoriaActiva
    );
  } else if (grupoActivo && subcategoriaActiva === 'Todas') {
    productosFiltrados = productosFiltrados.filter(p => 
      grupoActivo.categorias.includes(p.categoria)
    );
  } else if (categoriaActiva !== "Todas") {
    productosFiltrados = productosFiltrados.filter(p => p.categoria === categoriaActiva);
  }
  
  // 2. Ordenar productos
  const productosOrdenados = ordenarProductos(productosFiltrados, orden);
  
  // 3. Actualizar estado
  setProductosFiltradosCompletos(productosOrdenados);
  setPaginaActual(1); // Resetear a primera página
  
}, [todosLosProductos, grupoActivo, subcategoriaActiva, categoriaActiva, orden]);
  



  
  // Cargar categorías (se mantiene igual)
  useEffect(() => {
    const obtenerCategorias = async () => {
      try {
        const cats = await cargarCategorias();
        const categoriasUnicas = [...new Set(['Todas', ...(cats || [])])];
        setCategorias(categoriasUnicas);
      } catch (error) {
        console.error("❌ Error al cargar categorías:", error);
        setCategorias(['Todas']);
      }
    };
    
    obtenerCategorias();
  }, []);

  
  // Función para cambiar de página (ÚNICA VERSIÓN)
  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina);
    setTimeout(() => {
      scrollearSeccion("catalogo_seccion");
    }, 100);
  };

  // Total de páginas (ÚNICA VERSIÓN)
  const totalPaginas = Math.ceil(productosFiltradosCompletos.length / productosPorPagina);

// Modificar handleOrdenChange con retroalimentación visual
const handleOrdenChange = (e) => {
  const nuevoOrden = e.target.value;
  const ordenAnterior = orden;
  setOrden(nuevoOrden);
  
  // Verificar si el orden es diferente de "orden" (el predeterminado)
  if (nuevoOrden !== 'orden') {
    // Limpiar todos los filtros de categoría solo si venían de un filtro
    if (grupoActivo || categoriaActiva !== "Todas") {
      setGrupoActivo(null);
      setSubcategoriaActiva('Todas');
      setCategoriaActiva('Todas');
      
      // Mostrar mensaje informativo
      setTimeout(() => {
        const mensaje = `Ordenando por ${e.target.options[e.target.selectedIndex].text.toLowerCase()}. Los filtros de categoría han sido limpiados.`;
        console.log(mensaje); // O podrías mostrar un toast/notificación
      }, 100);
    }
  } else if (nuevoOrden === 'orden' && ordenAnterior !== 'orden') {
    // Si se vuelve al orden personalizado, puedes mantener los filtros limpios
    // o restablecer algún estado si lo prefieres
  }
};


// Efecto para actualizar los productos de la página actual
useEffect(() => {
  if (productosFiltradosCompletos.length === 0) {
    setProductosPaginaActual([]);
    return;
  }
  
  const inicio = (paginaActual - 1) * productosPorPagina;
  const fin = inicio + productosPorPagina;
  const productosPagina = productosFiltradosCompletos.slice(inicio, fin);
  setProductosPaginaActual(productosPagina);
  
  // Precargar imágenes de la página actual
  if (productosPagina.length > 0) {
    precargarImagenesPaginadas(productosPagina);
  }
}, [productosFiltradosCompletos, paginaActual, productosPorPagina]);





  // Componente PrecioProducto
  const PrecioProducto = ({ productoId, esRecomendado = false }) => {
    const precioData = esRecomendado ? preciosRecomendados[productoId] : preciosProductos[productoId];

    if (!precioData) {
      return (
        <div className="precio-container">
          <h3>Precio:</h3>
          <p className="product-price">-</p>
        </div>
      );
    }

    const tieneOfertaValida = precioData.enOferta && precioData.precioOferta && precioData.precioOferta > 0;

    if (tieneOfertaValida) {
      return (
        <div className="precio-container">
          <div className="precios">
            <h3>Precio:</h3>
            <p className="product-price-tachado">${precioData.precioNormal}</p>
          </div>
          <div className="precios">
            <h3>Oferta:</h3>
            <p className="product-price-oferta">${precioData.precioOferta}</p>
          </div>
        </div>
      );
    }






    return (
      <div className="precio-normal-container">
        <h3>Precio:</h3>
        <p className="product-price">${precioData.precioNormal}</p>
      </div>
    );
  };

  // Funciones de toggle
  const toggleCategorias = () => {
    setCategoriasAbierto(!categoriasAbierto);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  
  const toggleSearchMobile = () => setShowSearchMobile(!showSearchMobile);

  // Componente de navegación por grupos
  const NavegacionGrupos = () => {
    return (
      <div className="grupos-categorias">
        <div className="grupos-header">
          <h3>Explorar por categorías</h3>
        </div>
        
        <div className="grupos-container">
          {gruposCategorias.map(grupo => (
            <div 
              key={grupo.id} 
              className={`grupo-card ${grupoActivo?.id === grupo.id ? 'activo' : ''}`}
              onClick={() => handleGrupoClick(grupo)}
            >
              <div className="grupo-icon">
                <FontAwesomeIcon icon={grupo.icono} />
              </div>
              <h4>{grupo.nombre}</h4>
              <p>{grupo.categorias.length} subcategorías</p>
            </div>
          ))}
        </div>
        
        {/* Botón para aplicar filtro cuando hay grupo activo */}
        {grupoActivo && (
          <div className="grupo-acciones">
            <button className="btn-aplicar-filtro" onClick={aplicarFiltroGrupo}>
              Ver productos de {grupoActivo.nombre}
            </button>
            <button className="btn-limpiar-grupo" onClick={limpiarFiltros}>
              Limpiar
            </button>
          </div>
        )}
      </div>
    );
  };

  // Componente de subcategorías (CORREGIDO)
  const Subcategorias = () => {
    if (!grupoActivo) return null;
    
    return (
      <div className="grupo-seleccionado-info">
        <div className="grupo-seleccionado-header">
          <FontAwesomeIcon icon={grupoActivo.icono} />
          <h4>Grupo seleccionado: {grupoActivo.nombre}</h4>
          <button className="btn-cerrar-grupo" onClick={limpiarFiltros}>
            ×
          </button>
        </div>
        <div className="subcategorias-container">
          <div className="subcategorias-header">
            <h5>Selecciona una subcategoría:</h5>
          </div>
          
          <div className="subcategorias-grid">
            <button
              className={`subcategoria-btn ${subcategoriaActiva === 'Todas' ? 'activa todas' : ''}`}
              onClick={() => handleSubcategoriaClick('Todas')}
            >
              <FontAwesomeIcon icon={faTags} />
              <span>Todas las {grupoActivo.nombre.toLowerCase()}</span>
            </button>
            
            {grupoActivo.categorias.map((subcat, index) => (
              <button
                key={index}
                className={`subcategoria-btn ${subcategoriaActiva === subcat ? 'activa' : ''}`}
                onClick={() => handleSubcategoriaClick(subcat)}
              >
                <span>{subcat}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="App">
    {controlEdad && (
      <div className="overlay-edad">
        <div className="control_edad">
          <h2>¿Sos mayor de 18 años?</h2>
          <p>
            Este sitio está destinado a personas de mayores de edad.
            Promovemos el consumo responsable de bebidas alcohólicas.
          </p>
          <div className="botones">
            <button id="btnSi" onClick={confirmarEdad}>Sí</button>
            <button id="btnNo" onClick={() => alert("Acceso no permitido")}>No</button>
          </div>
        </div>
      </div>
    )}

    {menuVisible && <div className="overlay" onClick={() => setMenuVisible(false)}></div>}
    {menuOpen && <div className="overlay-mobile" onClick={toggleMenu}></div>}

    <header className="App-header">
      {/* Versión móvil */}
      <div className='mobile-izquierdo'>
        <button className="hamburger" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>

      {/* Menú móvil desplegable */}
      <nav className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <button className="close-menu" onClick={toggleMenu}>×</button>
        
        <button className='mobile-nav-button' onClick={() => {
          scrollearSeccion('seccion-portada');
          toggleMenu();
        }}>
          <FontAwesomeIcon icon={faHome} />
          <span>Inicio</span>
        </button>

        <button onClick={() => {
          scrollearSeccion('catalogo_seccion');
          toggleMenu();
        }} className='mobile-nav-button'>
          <FontAwesomeIcon icon={faBook} />
          <span>Catálogo</span>
        </button>

        {/* MENÚ MÓVIL DE CATEGORÍAS CON GRUPOS */}
        <div className={`mobile-dropdown-categorias ${categoriasAbierto ? 'active' : ''}`}>
          <button 
            className="mobile-nav-button mobile-categorias-toggle"
            onClick={toggleCategorias}
          >
            <FontAwesomeIcon icon={faTags} />
            <span>Categorías</span>
            <FontAwesomeIcon icon={faChevronDown} className="dropdown-arrow" />
          </button>
          
          <div className="mobile-categorias-container">
            <div className="mobile-categorias-scroll">
              {/* Botón para ver todas las categorías */}
              <button 
                className="mobile-categoria-item todas"
                onClick={() => {
                  setCategoriaActiva("Todas");
                  setGrupoActivo(null);
                  setSubcategoriaActiva('Todas');
                  setPaginaActual(1);
                  toggleMenu();
                  setCategoriasAbierto(false);
                  
                  setTimeout(() => {
                    scrollearSeccion("catalogo_seccion");
                  }, 100);
                }}
              >
                <FontAwesomeIcon icon={faTags} />
                <span>Todas las categorías</span>
              </button>
              
              {/* Grupos de categorías */}
              {gruposCategorias.map(grupo => (
                <div 
                  key={grupo.id} 
                  className="mobile-grupo-container"
                >
                  <button 
                    className={`mobile-grupo-toggle ${grupoAbiertoMobile?.id === grupo.id ? 'activo' : ''}`}
                    onClick={() => handleGrupoMobileClick(grupo)}
                  >
                    <FontAwesomeIcon icon={grupo.icono} />
                    <span>{grupo.nombre}</span>
                    <FontAwesomeIcon 
                      icon={faChevronDown} 
                      className={`mobile-grupo-arrow ${grupoAbiertoMobile?.id === grupo.id ? 'activo' : ''}`}
                    />
                  </button>
                  
                  {grupoAbiertoMobile?.id === grupo.id && (
                    <div className="mobile-subcategorias">
                      <button
                        className="mobile-subcategoria-item todas"
                        onClick={() => {
                          setGrupoActivo(grupo);
                          setSubcategoriaActiva('Todas');
                          setCategoriaActiva('Todas');
                          setPaginaActual(1);
                          toggleMenu();
                          setCategoriasAbierto(false);
                          setGrupoAbiertoMobile(null);
                          
                          setTimeout(() => {
                            scrollearSeccion("catalogo_seccion");
                          }, 100);
                        }}
                      >
                        <span>Todas las {grupo.nombre.toLowerCase()}</span>
                      </button>
                      
                      {grupo.categorias.map((subcat, index) => (
                        <button
                          key={index}
                          className="mobile-subcategoria-item"
                          onClick={() => handleSubcategoriaMobileClick(grupo, subcat)}
                        >
                          <span>{subcat}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <button className='mobile-nav-button' onClick={() => {
          navigate('/sobre-nosotros');
          toggleMenu();
        }}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <span>Sobre Nosotros</span>
        </button>

        <div className="mobile-user-actions">
          {logueado ? (
            <>
              <button className='mobile-logout-button' onClick={async () => {
                await supabase.auth.signOut();
                setLogueado(false);
                toggleMenu();
              }}>
                <FontAwesomeIcon icon={faSignInAlt} />
                <span>Cerrar Sesión</span>
              </button>
              <button className='mobile-admin-button' onClick={() => {
                navigate('/panel');
                toggleMenu();
              }}>
                <FontAwesomeIcon icon={faUserShield} />
                <span>Panel Admin</span>
              </button>
            </>
          ) : (
            <button className='mobile-login-button' onClick={() => {
              navigate('/login');
              toggleMenu();
            }}>
              <FontAwesomeIcon icon={faUser} />
              <span>Iniciar Sesión</span>
            </button>
          )}
        </div>
      </nav>

      <div className='mobile-central'>
        <div className='eslogan'>
          <h2>El Sabor del Roble</h2>
        </div>
      </div>

      <div className='mobile-derecho'>
        <button className="buscar-boton" onClick={toggleSearchMobile}>
          <FontAwesomeIcon icon={faSearch} size="lg" />
        </button>
        <button className='cart-button' onClick={() => setMenuVisible(true)}>
          <FontAwesomeIcon icon={faCartShopping} />
          <span className="cart-count">{carrito.reduce((acc, p) => acc + (p.cantidad || 1), 0)}</span>
        </button>
      </div>

      {/* Search mobile overlay */}
{showSearchMobile && (
  <div 
  className="mobile-search-overlay"
  onClick={(e) => {
    if (e.target === e.currentTarget) {
      toggleSearchMobile();
    }
  }}
  onMouseDown={(e) => e.stopPropagation()}  // ← EVITA QUE EL OVERLAY INTERCEPTE EL CLICK
>
    <div className="mobile-search-container">
      <div className="mobile-search-header">
        <div className="search-title-section">
          <FontAwesomeIcon icon={faSearch} className="search-title-icon" />
          <h3>Buscar productos</h3>
        </div>
        <button className="close-search" onClick={toggleSearchMobile}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      
      <div className="mobile-search-input-container">
        <div className="search-input-wrapper">
          <FontAwesomeIcon icon={faSearch} className="mobile-search-icon" />
          <input
            type="text"
            placeholder="¿Qué estás buscando?..."
            className='mobile-search-input'
            value={query}
            onChange={handleInputChange}
            onKeyDown={e => e.key === "Enter" && handleSearch()}
            autoFocus
          />
          {query && (
            <button 
              className="clear-search" 
              onClick={() => setQuery('')}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
      </div>
      
    
      
      {/* Resultados de búsqueda */}
      {showDropdown && query && (
        <div className="mobile-search-results">
          <div className="results-header">
            <span className="results-count">
              {resultados.length} resultado{resultados.length !== 1 ? 's' : ''} encontrado{resultados.length !== 1 ? 's' : ''}
            </span>
          </div>
          
          {resultados.length > 0 ? (
            <div className="results-grid">
              {resultados.map((r) => (
                <div
                  key={r.id}
                  className="mobile-search-result-card"
                  onClick={(e) => {
  e.preventDefault();
  e.stopPropagation();
  navigate(`/producto/${r.id}`);   // directo
  toggleSearchMobile();            // cerrar overlay
  setShowDropdown(false);
  setQuery('');
}}
                >
                  <div className="result-image-container">
                    <img src={r.imagen_url} alt={r.nombre} className="mobile-result-image" />
                    <span className="result-badge">{r.categoria}</span>
                  </div>
                  <div className="result-info">
                    <h4 className="result-name">{r.nombre}</h4>
                    <p className="result-description">
                      {r.descripcion ? r.descripcion.substring(0, 60) + '...' : 'Sin descripción'}
                    </p>
                    <div className="result-meta">
                      <span className="result-price">${r.precio}</span>
                      {r.precio_oferta && r.precio_oferta < r.precio && (
                        <span className="result-price-offer">${r.precio_oferta}</span>
                      )}
                      <span className={`result-stock ${r.stock > 5 ? "in-stock" : "low-stock"}`}>
                        {r.stock > 5 ? "En stock" : "Últimas unidades"}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results-state">
              <div className="no-results-icon">🔍</div>
              <h4>No encontramos resultados</h4>
              <p>Intenta con otros términos de búsqueda</p>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
)}

        {/* Carrito móvil */}
        <div className={`mobile-cart-overlay ${menuVisible ? 'active' : ''}`}>
          <div className="mobile-cart-container">
            <div className="mobile-cart-header">
              <h3>
                <FontAwesomeIcon icon={faCartShopping} /> Mi Carrito
                <span className="mobile-cart-count">
                  {carrito.reduce((acc, p) => acc + (p.cantidad || 1), 0)}
                </span>
              </h3>
              <button className="close-mobile-cart" onClick={() => setMenuVisible(false)}>
                ×
              </button>
            </div>

            <div className="mobile-cart-content">
              {carrito.length === 0 ? (
                <div className="mobile-cart-empty">
                  <div className="mobile-cart-empty-icon">🍷</div>
                  <h4>Tu carrito está vacío</h4>
                  <p>Agrega algunos productos para comenzar</p>
                </div>
              ) : (
                <div className="mobile-cart-items">
                  {carrito.map(producto => (
                    <div key={producto.id} className="mobile-cart-item">
                      <img 
                        src={producto.imagen_url} 
                        alt={producto.nombre} 
                        className="mobile-cart-item-image" 
                      />
                      <div className="mobile-cart-item-info">
                        <span className="mobile-cart-item-name">{producto.nombre}</span>
                        <span className="mobile-cart-item-price">${producto.precioVenta || producto.precio}</span>
                        <div className="mobile-cart-item-controls">
                          <button 
                            className="mobile-cart-btn menos" 
                            onClick={() => disminuirCantidad(producto.id)}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                          <span className="mobile-cart-quantity">{producto.cantidad || 1}</span>
                          <button 
                            className="mobile-cart-btn mas" 
                            onClick={() => aumentarCantidad(producto.id)}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {carrito.length > 0 && (
              <div className="mobile-cart-footer">
                <div className="mobile-cart-total">
                  <span>Total:</span>
                  <span className="mobile-total-amount">
                    ${carrito.reduce((total, prod) => total + ((prod.precioVenta || prod.precio) * (prod.cantidad || 1)), 0).toLocaleString()}
                  </span>
                </div>
                <button
                  className="mobile-checkout-btn"
                  onClick={() => {
                    if (carrito.length === 0) return alert("El carrito está vacío");

                    const mensaje = carrito
                      .map(item => {
                        const precioFinal = item.precioVenta || item.precio;
                        return `${item.cantidad} x ${item.nombre} - $${precioFinal}`;
                      })
                      .join('%0A');
                    
                    const total = carrito.reduce(
                      (total, prod) => total + ((prod.precioVenta || prod.precio) * (prod.cantidad || 1)),
                      0
                    );

                    const numero = '5493426126862';
                    const url = `https://wa.me/${numero}?text=Hola!%20Quisiera%20realizar%20el%20pedido:%0A${mensaje}%0ATotal: $${total.toLocaleString()}`;

                    window.open(url, '_blank');
                  }}
                >
                  <FontAwesomeIcon icon={faWhatsapp} /> Finalizar compra
                </button>
              </div>
            )}
          </div>
        </div>

       <div className='header-left'>
        <div className="logo-container">
          <div className='logan'>
            <h2>Almacen de Vinos</h2>
            <h3>El Sabor Del Roble</h3>
          </div>
        </div>
      </div>

      <div className='header-center'>
        <nav className="nav-menu">
          <button className='nav-button' onClick={() => scrollearSeccion('seccion-portada')}>
            <FontAwesomeIcon icon={faHome} />
            <span>Inicio</span>
          </button>

          <button onClick={() => scrollearSeccion('catalogo_seccion')} className='nav-button'>
            <FontAwesomeIcon icon={faBook} />
            <span>Catálogo</span>
          </button>
          
          <div className="dropdown-categorias">
            <button className="nav-button">
              <FontAwesomeIcon icon={faTags} />
              <span>Categorías</span>
            </button>
            <ul className="dropdown-menu">
              {categorias.map((cat) => (
                <li key={cat} onClick={() => handleCategoriaClick(cat)}>{cat}</li>
              ))}
            </ul>
          </div>
          
          <button className='nav-button' onClick={() => navigate('/sobre-nosotros')}>
            <FontAwesomeIcon icon={faInfoCircle} />
            <span>Sobre Nosotros</span>
          </button>
        </nav>
      </div>

        <div className='header-right'>
          <div className="search-bar" ref={searchRef}>
            <div className="search-container">
              <FontAwesomeIcon icon={faSearch} className="search-icon" onClick={handleSearch} />
              <input
                type="text"
                placeholder="Buscar productos..."
                className='search-input'
                value={query}
                onChange={handleInputChange}
                onKeyDown={e => e.key === "Enter" && handleSearch()}
                onFocus={() => query && setShowDropdown(true)}
              />
            </div>

            {showDropdown && (
              <ul className="dropdown-search">
                {resultados.length > 0 ? (
                  resultados.map((r) => (
                    <li
                      key={r.id}
                      className="dropdown-item"
                      onClick={() => {
                        navigate(`/producto/${r.id}`);
                        setShowDropdown(false);
                        setQuery('');
                      }}
                    >
                      <span className="item-nombre">{r.nombre}</span>
                      <span className="item-tipo">{r.categoria}</span>
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item empty">
                    No se encontraron productos
                  </li>
                )}
              </ul>
            )}
          </div>
          
          <div className="user-actions">
            <button className='cart-button' onClick={() => setMenuVisible(true)}>
              <FontAwesomeIcon icon={faCartShopping} />
              <span className="cart-count">
                {carrito.reduce((acc, p) => acc + (p.cantidad || 1), 0)}
              </span>
            </button>

            {logueado ? (
              <>
                <button
                  className='logout-button'
                  onClick={async () => {
                    await supabase.auth.signOut();
                    setLogueado(false);
                  }}
                >
                  <FontAwesomeIcon icon={faSignInAlt} />
                </button>

                <button className='admin-button' onClick={() => navigate('/panel')}>
                  <FontAwesomeIcon icon={faUserShield} />
                </button>
              </>
            ) : (
              <button className='login-button' onClick={() => navigate('/login')}>
                <FontAwesomeIcon icon={faUser} />
              </button>
            )}
          </div>
        </div>
      </header>

      <main id='seccion-portada'>
        <div className='portada'>
          <img src={logo} className="Portada-logo" alt="logo-portada" />
        </div>

       {/* Sección de navegación por grupos */}
<section className="seccion-grupos">
  <div className="contenedor-grupos">

    <div className="grupos-principales">
      <div className="grupos-header">
        <h3>Explorar por categorías</h3>
        <p>Selecciona un grupo para ver sus subcategorías</p>
      </div>

      <div className="grupos-container">
        {gruposCategorias.map((grupo) => (
          <div
            key={grupo.id}
            className={`grupo-card ${
              grupoActivo?.id === grupo.id ? "activo" : ""
            }`}
            onClick={() => handleGrupoClick(grupo)}
          >
            <div className="grupo-icon">
              <FontAwesomeIcon icon={grupo.icono} />
            </div>
            <h4>{grupo.nombre}</h4>
            <p>{grupo.categorias.length} subcategorías</p>
          </div>
        ))}
      </div>
    </div>

    {/* Subcategorías (solo cuando hay grupo activo) */}
    <Subcategorias />
  </div>
</section>


        {/* Recomendados con Carrusel */}
        <section className="recomendados">
          <div className="recomendados-header">
            <h2 id="recomendados">Los recomendados del Mes</h2>
            <p>Una selección especial pensada para vos</p>
          </div>

          <div className="recomendados-carrusel-container">
            {productosRecomendados.length === 0 ? (
              <div className="sin-recomendados">
                <p>No hay productos recomendados en este momento</p>
              </div>
            ) : (
              <>
                <div className="recomendados-grid">
                  {productosVisibles.map((producto) => {
                    const imagenActual = obtenerImagenActualRecomendados(producto);
                    const multiplesImagenes = tieneMultiplesImagenes(producto);
                    
                    return (
                      <div key={producto.id} className="product-card" onClick={() => navigate(`/producto/${producto.id}`)} style={{ cursor: "pointer" }}>
                        <div className="product-image-container">
                          <div className={`image-wrapper ${transicionImagenRecomendados[producto.id] || ''}`}>
                            <img src={imagenActual} alt={producto.nombre} className="product-image"/>
                          </div>
                          
                          {multiplesImagenes && (
                            <>
                              <button 
                                className="carousel-btn left" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  cambiarImagenRecomendados(producto.id, 'prev');
                                }}
                              >
                                <FaChevronLeft/>
                              </button>
                              <button 
                                className="carousel-btn right" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  cambiarImagenRecomendados(producto.id, 'next');
                                }}
                              >
                                <FaChevronRight/>
                              </button>
                            </>
                          )}
                          
                          <span className="product-badge">{producto.categoria}</span>
                        </div>
                        <div className="product-info">
                          <h3 className="product-title">{producto.nombre}</h3>
                          <p className="product-description">{producto.detalle}</p>
                          <PrecioProducto productoId={producto.id} esRecomendado={true} />
                          <div className="product-meta">
                            <p className={`product-stock ${producto.stock > 5 ? "in-stock" : "low-stock"}`}>
                              {producto.stock > 5 ? "En stock" : "Últimas unidades"}
                            </p>
                          </div>
                          <div className="product-buttons">
                            <button className="add-to-cart-button" onClick={(e) => {
                              e.stopPropagation();
                              añadirAlCarrito(producto);
                            }}>
                              <FontAwesomeIcon icon={faCartShopping} /> Agregar al Carrito
                            </button>
                            <a
                              href={`https://wa.me/5493426126862?text=Hola%20quiero%20comprar%20el%20producto%20${encodeURIComponent(producto.nombre)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="whatsapp-button"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FontAwesomeIcon icon={faWhatsapp} /> Consultar
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {productosRecomendados.length > 4 && (
                  <div className="carrusel-controles-final">
                    <div className="carrusel-indicadores">
                      {[...Array(Math.ceil(productosRecomendados.length / 4))].map((_, index) => (
                        <button
                          key={index}
                          className={`indicador ${indiceCarruselRecomendados === index ? 'activo' : ''}`}
                          onClick={() => irAPagina(index)}
                          aria-label={`Ir a página ${index + 1}`}
                        />
                      ))}
                    </div>
                    
                    <div className="carrusel-botones-container">
                      <button 
                        className="carrusel-btn carrusel-prev" 
                        onClick={anteriorRecomendado}
                        aria-label="Productos anteriores"
                      >
                        <FaChevronLeft /> Anterior
                      </button>
                      
                      <button 
                        className="carrusel-btn carrusel-next" 
                        onClick={siguienteRecomendado}
                        aria-label="Siguientes productos"
                      >
                        Siguiente <FaChevronRight />
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </section>

        {/* Carrito PC */}
        <aside className={`menu-lateral ${menuVisible ? 'activo' : ''}`}>
          <div className="carrito-header">
            <h3>
              <FontAwesomeIcon icon={faCartShopping} /> Mi Carrito
            </h3>
          </div>

          <ul>
            {carrito.length === 0 ? (
              <div className="carrito-vacio">
                <div className="carrito-vacio-icon">🍷</div>
                <h4>Tu carrito está vacío</h4>
                <p>Agrega algunos productos para comenzar</p>
              </div>
            ) : (
              carrito.map(producto => (
                <li key={producto.id} className="producto-item">
                  <div className="producto-info">
                    <img 
                      src={producto.imagen_url} 
                      alt={producto.nombre} 
                      className="producto-miniatura" 
                    />
                    <span title={producto.nombre}>{producto.nombre}</span>
                  </div>

                  <div className="controles">
                    <div className="control-cantidad">
                      <button 
                        className="btn-cantidad menos" 
                        onClick={() => disminuirCantidad(producto.id)} 
                        title="Disminuir cantidad"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>

                      <span>{producto.cantidad || 1}</span>

                      <button 
                        className="btn-cantidad mas" 
                        onClick={() => aumentarCantidad(producto.id)} 
                        title="Aumentar cantidad"
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                  </div>
                </li>
              ))
            )}
          </ul>

          {carrito.length > 0 && (
            <div className="carrito-footer">
              <div className="total-container">
                <span className="total-label">Total:</span>
                <span className="total-monto">
                  ${carrito.reduce((total, prod) => total + ((prod.precioVenta || prod.precio) * (prod.cantidad || 1)), 0).toLocaleString()}
                </span>
              </div>
              <button className="finalizar-compra" onClick={() => {
                if (carrito.length === 0) return alert("El carrito está vacío");

                const mensaje = carrito
                  .map(item => {
                    const precioFinal = item.precioVenta || item.precio;
                    return `${item.cantidad} x ${item.nombre} - $${precioFinal}`;
                  })
                  .join('%0A');
                
                const total = carrito.reduce(
                  (total, prod) => total + ((prod.precioVenta || prod.precio) * (prod.cantidad || 1)),
                  0
                );

                const numero = '5493426126862';
                const url = `https://wa.me/${numero}?text=Hola!%20Quisiera%20realizar%20el%20pedido:%0A${mensaje}%0ATotal: $${total.toLocaleString()}`;

                window.open(url, '_blank');
              }}>
                <FontAwesomeIcon icon={faWhatsapp} /> Finalizar
              </button>
            </div>
          )}
        </aside>

     {/* Catálogo */}
          {/* Catálogo */}
<section id="catalogo_seccion" className='catalogo'>
  <div className="catalogo-header">
    <h2>Catálogo de Productos</h2>
    <p>Descubre nuestra selección de productos únicos y exclusivos</p>
    
    <div className="ordenamiento-container">
      <label htmlFor="orden-select">Ordenar por: </label>
      <select 
        id="orden-select"
        value={orden} 
        onChange={handleOrdenChange}
        className="orden-select"
      >
        <option value="orden">Orden personalizado</option>
        <option value="precio_asc">Precio: Menor a Mayor</option>
        <option value="precio_desc">Precio: Mayor a Menor</option>
        <option value="nombre_asc">Nombre: A-Z</option>
        <option value="nombre_desc">Nombre: Z-A</option>
      </select>
      
      
    </div>

        {orden !== 'orden' && (
        <div className="orden-info-message">
          <small>
            <FontAwesomeIcon icon={faInfoCircle} /> 
            Mostrando todos los productos sin filtros de categoría.
          </small>
          <button 
            className="btn-reset-orden"
            onClick={() => setOrden('orden')}
          >
            Restablecer orden
          </button>
        </div>
      )}  
  </div>
  
  {/* Mostrar información sobre la categoría seleccionada */}
  {(grupoActivo || categoriaActiva !== "Todas") && (
    <div className="filtro-activo-info">
      {grupoActivo ? (
        <div className="filtro-info-contenido">
          <FontAwesomeIcon icon={grupoActivo.icono} />
          <span>
            Filtrando por: <strong>{grupoActivo.nombre}</strong>
            {subcategoriaActiva !== 'Todas' && ` > ${subcategoriaActiva}`}
          </span>
          <button className="btn-limpiar-pequeno" onClick={limpiarFiltros}>
            ×
          </button>
        </div>
      ) : (
        <div className="filtro-info-contenido">
          <FontAwesomeIcon icon={faTags} />
          <span>Filtrando por categoría: <strong>{categoriaActiva}</strong></span>
          <button className="btn-limpiar-pequeno" onClick={limpiarFiltros}>
            ×
          </button>
        </div>
      )}
    </div>
  )}
  
  {productosPaginaActual.length === 0 ? (
    <div className="sin-productos">
      <div className="sin-productos-icon">🍷</div>
      <h3>No se encontraron productos</h3>
      
      {/* Mensaje específico según el filtro */}
      {grupoActivo && subcategoriaActiva !== 'Todas' ? (
        <>
          <p>No hay productos en la categoría <strong>"{subcategoriaActiva}"</strong>.</p>
          <div className="opciones-sin-productos">
            <button className="btn-opcion" onClick={() => handleSubcategoriaClick('Todas')}>
              Ver todos los {grupoActivo.nombre.toLowerCase()}
            </button>
            <button className="btn-opcion" onClick={limpiarFiltros}>
              Ver todas las categorías
            </button>
          </div>
        </>
      ) : grupoActivo ? (
        <>
          <p>No hay productos en el grupo <strong>"{grupoActivo.nombre}"</strong>.</p>
          <div className="opciones-sin-productos">
            <button className="btn-opcion" onClick={limpiarFiltros}>
              Ver todas las categorías
            </button>
            <button className="btn-opcion" onClick={() => setGrupoActivo(null)}>
              Seleccionar otro grupo
            </button>
          </div>
        </>
      ) : categoriaActiva !== "Todas" ? (
        <>
          <p>No hay productos en la categoría <strong>"{categoriaActiva}"</strong>.</p>
          <div className="opciones-sin-productos">
            <button className="btn-opcion" onClick={limpiarFiltros}>
              Ver todas las categorías
            </button>
          </div>
        </>
      ) : orden !== 'orden' ? (
        <p>Mostrando todos los productos ordenados por {getOrdenText(orden)}</p>
      ) : (
        <p>Intenta ajustar los filtros de búsqueda</p>
      )}
      
      <button className="btn-limpiar-todo" onClick={limpiarFiltros}>
        Ver todos los productos
      </button>
    </div>
  ) : (
    <>
      <div className="product-grid-3-columns">
        {productosPaginaActual.map((producto) => {
          const imagenActual = obtenerImagenActualCatalogo(producto);
          const multiplesImagenes = tieneMultiplesImagenes(producto);
          
          return (
            <div 
              key={producto.id} 
              id={`producto-${producto.id}`} 
              onClick={() => navigate(`/producto/${producto.id}`)}
              style={{ cursor: 'pointer' }} 
              className="product-card"
            >
              <div className="product-image-container">
                <div className={`image-wrapper ${transicionImagenCatalogo[producto.id] || ''}`}>
                  <img 
                    src={imagenActual} 
                    alt={producto.nombre} 
                    className="product-image"
                  />
                </div>
                
                {multiplesImagenes && (
                  <>
                    <button 
                      className="carousel-btn left" 
                      onClick={(e) => {
                        e.stopPropagation();
                        cambiarImagenCatalogo(producto.id, 'prev');
                      }}
                    >
                      <FaChevronLeft/>
                    </button>
                    <button 
                      className="carousel-btn right" 
                      onClick={(e) => {
                        e.stopPropagation();
                        cambiarImagenCatalogo(producto.id, 'next');
                      }}
                    >
                      <FaChevronRight/>
                    </button>
                  </>
                )}
                
                <span className="product-badge">{producto.categoria}</span>
              </div>
              <div className="product-info">
                <h3 className="product-title">{producto.nombre}</h3>
                <p className="product-description">{producto.detalle}</p>
                <PrecioProducto productoId={producto.id} />
                <div className="product-meta">
                  <p className={`product-stock ${producto.stock > 5 ? "in-stock" : "low-stock"}`}>
                    {producto.stock > 5 ? "En stock" : "Últimas unidades"}
                  </p>
                </div>
                <div className="product-buttons">
                  <button className="add-to-cart-button" onClick={(e) => {
                    e.stopPropagation();
                    añadirAlCarrito(producto);
                  }}>
                    <FontAwesomeIcon icon={faCartShopping} /> Agregar al Carrito
                  </button>
                  <a
                    href={`https://wa.me/5493426126862?text=Hola%20quiero%20comprar%20el%20producto%20${encodeURIComponent(producto.nombre)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-button"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} /> Consultar
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Paginación - SOLO se muestra cuando hay productos */}
      {totalPaginas > 1 && (
        <div className="paginacion">
          <button 
            className={`pagina-btn ${paginaActual === 1 ? 'disabled' : ''}`}
            onClick={() => cambiarPagina(paginaActual - 1)}
            disabled={paginaActual === 1}
          >
            Anterior
          </button>
          
          <div className="numeros-pagina">
            {[...Array(totalPaginas)].map((_, index) => {
              const paginaNumero = index + 1;
              
              // Mostrar solo algunas páginas alrededor de la actual
              if (
                paginaNumero === 1 || 
                paginaNumero === totalPaginas ||
                (paginaNumero >= paginaActual - 1 && paginaNumero <= paginaActual + 1)
              ) {
                return (
                  <button
                    key={paginaNumero}
                    className={`numero-pagina ${paginaActual === paginaNumero ? 'activa' : ''}`}
                    onClick={() => cambiarPagina(paginaNumero)}
                  >
                    {paginaNumero}
                  </button>
                );
              } else if (
                paginaNumero === paginaActual - 2 ||
                paginaNumero === paginaActual + 2
              ) {
                return <span key={paginaNumero} className="puntos-pagina">...</span>;
              }
              return null;
            })}
          </div>
          
          <button 
            className={`pagina-btn ${paginaActual === totalPaginas ? 'disabled' : ''}`}
            onClick={() => cambiarPagina(paginaActual + 1)}
            disabled={paginaActual === totalPaginas}
          >
            Siguiente
          </button>
        </div>
      )}
    </>
  )}
</section>
        
        <button id="boton-index-whatsapp" 
          onClick={() => window.open("https://wa.me/5493426126862?text=Hola,%20quiero%20más%20información", "_blank")}>
          <FontAwesomeIcon icon={faWhatsapp} />
        </button>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <h3>El Sabor del Roble</h3>
            <p>Tradición y calidad en cada copa</p>
          </div>
          <div className="footer-links">
            <a 
              href="/sobre-nosotros" 
              onClick={(e) => {
                e.preventDefault();
                navigate('/sobre-nosotros');
              }}
            >
              Nosotros
            </a>
            
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                if (window.location.pathname !== '/') {
                  navigate('/');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 300);
                } else {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
            >
              Catálogo
            </a>
            
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                const phoneNumber = "5493426126862";
                const message = "Hola! Me interesa conocer más sobre sus productos";
                const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
              }}
            >
              Contacto
            </a>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=100059121583485" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.instagram.com/vinosaboraroble?igsh=MzljY2xmZmRxaXBy" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://wa.me/5493426126862" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 El Sabor del Roble. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}



